define('washare', ['jquery'], function ($) {

  var washare = {
    shareButton: $('#js_productShareBtn'),
    fallbackWrapper: $('#js_shareFallbackWrapper'),
    fallBackIcons: $('.product__share--icons'),
    url: $('[rel="canonical"]').attr('href'),
    text: $('[itemprop="description"]').html(),
    checkShareAPI: function checkShareAPI() {
      !!navigator.share && window.isTouchDevice ? this.nativeShare() : '';
    },
    nativeShare: function nativeShare() {
      var _this = this;

      this.shareButton.css('display', 'flex').on('click', function (e) {
        e.preventDefault();
        navigator.share({
          title: document.title,
          text: _this.text,
          url: _this.url
        });
      });
    },
    init: function init() {
      this.checkShareAPI();
    }
  };

  return washare;
});

